import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { BaseProductCard } from './components/BaseProductCard';
import { CategoriesListCard } from './components/CategoriesListCard';
import { ProductDeleteCard } from './components/ProductDeleteCard';
import { ProductDetailsCard } from './components/ProductDetailsCard';
import { ProductVariantsListCard } from './components/ProductVariantsListCard';

export function ProductDetails() {
    const { id } = useParams();

    const productQueryResults = useQuery({
        queryKey: ['product', id],
        queryFn: () => Api.Products.Products.getProduct(Number(id)),
    });

    const activePage = useActivePage();
    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Dashboard',
            path: `/`,
        },
        {
            title: 'Products',
            path: `/products`,
        },
        {
            title: 'Details',
            path: `products/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={productQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <ProductDetailsCard product={data} />
                        {data.baseProduct ? (
                            <BaseProductCard
                                product={data.baseProduct}
                                brand={data.brand}
                            />
                        ) : (
                            <ProductVariantsListCard
                                product={data}
                                refetch={productQueryResults.refetch}
                            />
                        )}

                        <CategoriesListCard
                            product={data}
                            refetch={productQueryResults.refetch}
                        />

                        {!data?.flavorVariants?.length && (
                            <Can I="delete" a="Product">
                                <ProductDeleteCard product={data} />
                            </Can>
                        )}
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
